import React from 'react';

import { Navbar, NavbarBrand } from 'reactstrap';

import './Header.scss';
import Logo from './assets/logo.png';

class Header extends React.Component {
  render () {
    return (
      <div className='page-layout__navbar--main'>
        <div className='container HeaderNav'>
          <Navbar inverse toggleable>
            <NavbarBrand href='/company'>
              <img alt='Paragon One' className='header__LogoImage' src={Logo} />
            </NavbarBrand>
          </Navbar>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/routes/magic/layouts/Header/index.js